import { Spacer } from "../../../../components/spacer/Spacer"
import { IconType, theme } from "../../../../styles/stitches.config"
import { useMemo, useState } from "react"
import DailyPriceLineChartWithResponsiveContainer from "../../../../components/chart/DailyPriceLineChart"
import { trpc } from "../../../../api/trpc/trpc"
import LoadingPage from "../../../Loading"
import { useWorstToBestPriceLevels } from "../../../../components/chart/hooks"
import { useTranslation } from "react-i18next"
import { SPricePointsContainer } from "./Spot.styled"
import { PageContainer } from "../containers"
import { PriceInfo, getIconProps } from "../../dailyPrices/PriceInfo"
import { startOfDay } from "date-fns"

const PricePoints = ({
  lowestPrice,
  currentPrice,
  highestPrice,
}: {
  lowestPrice: number
  highestPrice: number
  currentPrice?: number
}) => {
  const faceState = useWorstToBestPriceLevels(lowestPrice, highestPrice, currentPrice)
  const currentFaceProps = useMemo(() => getIconProps(faceState), [faceState])
  const { t } = useTranslation(["microsite"])

  return (
    <SPricePointsContainer>
      <>
        <PriceInfo icon="FaceWorst" label={t("microsite:daily_prices_highest_price")} price={highestPrice} />
        <PriceInfo
          icon={currentFaceProps.icon as IconType}
          asCard
          label={t("microsite:daily_prices_current_price")}
          price={currentPrice}
        />
        <PriceInfo icon="FaceBest" label={t("microsite:daily_prices_lowest_price")} price={lowestPrice} />
      </>
    </SPricePointsContainer>
  )
}

type Props = {
  prices: { priceCzk: number; date: Date }[]
  highestPrice: number
  lowestPrice: number
  currentValueIndex?: number
  date: Date
  isFetching?: boolean
}

const SpotContent = ({ prices, ...props }: Props) => {
  return (
    <>
      <Spacer size={theme.space.s4_5} />

      <DailyPriceLineChartWithResponsiveContainer
        prices={prices}
        currentValueIndex={props.currentValueIndex}
        loading={props.isFetching}
      />

      <Spacer size={theme.space.s4_5} />

      <PricePoints
        {...props}
        currentPrice={props.currentValueIndex !== undefined ? prices[props.currentValueIndex]?.priceCzk : undefined}
      />
    </>
  )
}

export const Spot = () => {
  const [date] = useState(startOfDay(new Date()))
  const { data, isLoading, isFetching } = trpc.useQuery(["dailyPricesWeb.hourlyPrices", { date }])

  if (isLoading || !data) {
    return <LoadingPage />
  }

  return (
    <PageContainer>
      <SpotContent {...data} date={date} isFetching={isFetching} />
    </PageContainer>
  )
}
